//@flow
import React, { Component } from "react";
import {
  View,
  Text,
  Keyboard,
  Dimensions,
  StyleSheet,
  Platform,
  TouchableOpacity,
} from "react-native";
import { connect } from "react-redux";
import { changeNavField } from "@microdoing/shared/services/nav/actions";
import Colors from "@microdoing/shared/constants/Colors";
import i18n from "@microdoing/shared/i18n";
import { widthPercentageToDP as wp } from "react-native-responsive-screen";
import AppIntroSlider from "react-native-app-intro-slider";
import ProgressAnimation from "./ProgressLottie";
import BookAnimation from "./BookLottie";
import ValueAnimation from "./ValueLottie";
import StarsAnimation from "./StarsLottie";
import { getIsConnected } from "@microdoing/shared/services/network/selectors";
import { MainText } from "app/components/common";
import theme from "app/Theme/Theme";

const { width, height } = Dimensions.get("window");

type Props = {};
type State = {
  email: string,
  password: string,
  isAuthenticate: boolean,
};

const getSlides = () => [
  {
    key: "somethun",
    index: 0,
    title: i18n.t("intro-title-1"),
    text: i18n.t("intro-text-1"),
    animation: playing => (
      <ProgressAnimation size={width * 0.8} playing={playing} />
    ),
    backgroundColor: "#59b2ab",
  },
  {
    key: "somethun-dos",
    index: 1,
    title: i18n.t("intro-title-2"),
    text: i18n.t("intro-text-2"),
    animation: playing => (
      <BookAnimation size={width * 1.2} playing={playing} />
    ),
    backgroundColor: "#febe29",
  },
  {
    key: "top-dos",
    index: 2,
    title: i18n.t("intro-title-3"),
    text: i18n.t("intro-text-3"),
    animation: playing => (
      <ValueAnimation size={width * 1.1} playing={playing} />
    ),
    backgroundColor: "#febe29",
  },
  {
    key: "somethun1",
    index: 3,
    title: i18n.t("intro-title-4"),
    text: i18n.t("intro-text-4"),
    animation: playing => (
      <StarsAnimation size={width * 1.1} playing={playing} />
    ),
    backgroundColor: "#22bcb5",
  },
];

class WelcomeScreen extends Component<Props, State> {
  state = {
    index: 0,
  };

  componentDidMount = () => {
    this.props.changeNavField({
      safeAreaViewBackgroundColor: theme.colors["neutral.white"],
    });
    Keyboard.dismiss();
  };

  onPressSignup = () => {
    this.props.navigation.navigate("SignupSetupName");
  };

  onDone = () => {
    this.onPressSignup();
  };

  // * ici j'ai modif en pensant que c'etait la page de carousel
  // * mais non, je ne sais pas c'est quelle page
  renderItem = (item, index) => {
    return (
      <View style={styles.slide}>
        <View style={styles.animation}>
          {item.animation(item.index === this.state.index)}
        </View>
        <MainText
          variant="l4-medium"
          textAlign="center"
          alignSelf="center"
          width="100%"
          color="brand.500"
        >
          {item.text}
        </MainText>
        <MainText
          variant="l4-medium"
          textAlign="center"
          alignSelf="center"
          width="100%"
          color="brand.500"
        >
          {item.text}
        </MainText>
      </View>
    );
  };

  renderNextButton = () => {
    return (
      <View>
        <TouchableOpacity style={styles.nextButton} testID="intro-next">
          <Text style={styles.nextText}>{i18n.t("next")}</Text>
        </TouchableOpacity>
      </View>
    );
  };

  onSlideChange = (index, lastIndex) => {
    this.setState({ index });
  };

  render() {
    return (
      <View style={styles.mainViewStyle} testID="welcome-screen">
        <AppIntroSlider
          scrollEnabled={Platform.OS === "ios" ? true : false}
          skipLabel={i18n.t("skip")}
          doneLabel={i18n.t("done")}
          nextLabel={i18n.t("next")}
          prevLabel={i18n.t("back")}
          textStyle={{ color: theme.colors["neutral.900"] }}
          buttonTextStyle={{ color: theme.colors["neutral.900"] }}
          showSkipButton
          showPrevButton
          onSlideChange={this.onSlideChange}
          activeDotStyle={{ backgroundColor: theme.colors["neutral.900"] }}
          renderItem={this.renderItem}
          slides={getSlides()}
          onDone={this.onDone}
        />
      </View>
    );
  }
}

const styles = StyleSheet.create({
  slide: {
    flex: 1,
    backgroundColor: "white",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "column",
  },
  title: {
    textAlign: "center",
    alignSelf: "center",
    marginTop: 20,
    marginBottom: 10,
    marginLeft: 10,
    marginRight: 10,
    width: wp("90%"),
    fontSize: wp("6%"),
    fontWeight: "bold",
    color: theme.colors["neutral.900"],
  },
  text: {
    textAlign: "center",
    alignSelf: "center",
    lineHeight: 28,
    flex: 1,
    zIndex: 5,
    fontSize: wp("4.5%"),
    width: wp("90%"),
    color: theme.colors["neutral.900"],
  },
  animation: {
    flex: 2,
    zIndex: -5,
    alignItems: "center",
    justifyContent: "center",
  },
  mainViewStyle: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
  nextButton: {
    backgroundColor: Colors.skyBlue,
    paddingLeft: 10,
    paddingRight: 10,
    paddingBottom: 5,
    paddingTop: 5,
    alignItems: "center",
    justifyContent: "center",
  },
  nextText: {
    color: theme.colors["neutral.white"],
    fontWeight: "bold",
  },
});

const mapStateToProps = state => {
  return {
    error: state.login.error,
    login: state.login,
    user: state.user,
    isConnected: getIsConnected(state),
  };
};

export default connect(mapStateToProps, {
  changeNavField,
})(WelcomeScreen);
